import { useEffect } from 'react';

import { isInvalidLearnLang } from 'src/viewLayer/helpers/validateLearnLang';
import { trackNodeShown } from 'src/dataLayer/remoteData/babbelEventStream';
import type { FlowConfig } from 'src/viewLayer/components/Flow/types';

interface UseNodeTrackerParams {
  learnLang: string;
  nodeNumber: number;
  flowConfig?: FlowConfig;
  isInvalidNodeNumber?: boolean;
};

const useNodeTracker = ({
  learnLang,
  nodeNumber,
  flowConfig,
  isInvalidNodeNumber
}: UseNodeTrackerParams): void => {
  useEffect(() => {
    if (flowConfig && !isInvalidNodeNumber && !isInvalidLearnLang(learnLang)) {
      const { id, version, flow } = flowConfig;

      trackNodeShown({
        learnLang,
        nodeNumber,
        flowId: id,
        flowVersion: version,
        flowLength: flow.length,
        nodeType: flow[nodeNumber].type
      });
    }
  }, [learnLang, nodeNumber, flowConfig, isInvalidNodeNumber]);
};

export default useNodeTracker;
